import ReportController from './report.controller';

export default class OrganisationPaxReportController extends ReportController
{
	get endpoint() {
		return 'organisation-pax';
	}

	get title() {
		return 'Organisation Pax Report';
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/organisation-pax.report.controller.js
 **/